import { getRaw, ApiResponse } from 'services/api';

export const WHATSAPP_MESSAGES_URL = '/i/whatsAppMessages';

/**
 * Fetches inbound SMS messages
 */
export const getWhatsAppMessages = (): Promise<ApiResponse> => getRaw(WHATSAPP_MESSAGES_URL);
